import { useState } from "react";
import {
  PaymentMethod,
  PaymentMethodE,
} from "../../../../Api/dto/Competition_POST_PUT";
import {
  border,
  Button,
  HStack,
  Icon,
  IconButton,
  Text,
  Tooltip,
  transition,
  VStack,
} from "@chakra-ui/react";
import { SvgComponent as SwishLogo } from "../swishicon";

export interface PaymentMethodSubstepState {
  paymentMethod: PaymentMethodE | null;
  fee: number;
  valid: boolean;
}

interface StateAndModifiers {
  state: PaymentMethodSubstepState;
  modifiers: {
    setPaymentMethod: (paymentMethod: PaymentMethod) => void;
  };
}

export function useSubstepGetPaymentMethod() {
  const [state, setState] = useState<PaymentMethodSubstepState>({
    paymentMethod: null,
    fee: 0,
    valid: false,
  });

  const setPaymentMethod = (pm: PaymentMethod) =>
    setState({
      paymentMethod: pm.paymentMethod,
      fee: pm.feeInSek,
      valid: true,
    });

  return {
    state,
    modifiers: { setPaymentMethod: setPaymentMethod },
  } as StateAndModifiers;
}

export function PaymentMethodSelector(
  props: StateAndModifiers & {
    paymentMethods: Array<PaymentMethod>;
    onSelect: () => void;
  }
) {
  return (
    <VStack>
      <Text maxW={"600px"} fontStyle={"italic"} fontSize={"14px"}>
        <Text as="span" textDecoration="underline">
          Betala med Swish
        </Text>{" "}
        för att underlätta vårt administrativa arbete! Faktura är endast ett
        alternativ för företag/föreningar.
      </Text>
      {props.paymentMethods.map((pm) => {
        const isInvoice = pm.paymentMethod == PaymentMethodE.INVOICE_MAN;
        return (
          <Tooltip
            hidden={!isInvoice}
            label={
              "Extra administrativt arbete, endast företag eller föreningar"
            }
          >
            {pm.paymentMethod === PaymentMethodE.SWISH_AUTO ? (
              <IconButton
                width={"100%"}
                shadow={"xl"}
                padding={"40px"}
                margin={"20px"}
                border={"1px"}
                borderColor={"gray.300"}
                outlineColor={"gray.100"}
                maxWidth={"500px"}
                icon={
                  <Icon
                    as={SwishLogo}
                    boxSize={"xs"}
                    height={"50px"}
                    width={"100%"}
                    marginBottom={"10px"}
                  />
                }
                _hover={{ transform: "scale(1.1)" }}
                transition="transform 0.3s ease"
                aria-label={"Swish"}
                onClick={() => {
                  props.modifiers.setPaymentMethod(pm);
                  props.onSelect();
                }}
              />
            ) : (
              <Button
                key={pm.paymentMethod}
                width={"70%"}
                fontSize={"md"}
                shadow={"xl"}
                padding={"30px"}
                margin={"20px"}
                maxWidth={"500px"}
                _hover={{ transform: "scale(1.1)" }}
                transition="transform 0.3s ease"
                onClick={() => {
                  props.modifiers.setPaymentMethod(pm);
                  props.onSelect();
                }}
              >
                <VStack>
                  <Text>
                    {paymentMethodToString(pm.paymentMethod) +
                      (pm.feeInSek > 0 ? " (+" + pm.feeInSek + " kr)" : "")}
                  </Text>
                  <Text
                    hidden={!isInvoice}
                    fontSize={"12px"}
                    fontStyle={"italic"}
                    textColor={"gray.700"}
                  >
                    {"(företag/föreningar)"}
                  </Text>
                </VStack>
              </Button>
            )}
          </Tooltip>
        );
      })}
    </VStack>
  );
}

export function paymentMethodToString(paymentMethod: PaymentMethodE | null) {
  if (paymentMethod == PaymentMethodE.INVOICE_MAN) {
    return "Faktura";
  } else if (paymentMethod == PaymentMethodE.SWISH_AUTO) {
    return "Swish";
  } else if (paymentMethod == PaymentMethodE.DIRECT_MAN) {
    return "Bankgiro";
  } else if (paymentMethod == PaymentMethodE.SWISH_MAN) {
    return "Swish manuell";
  } else {
    return "Ingen betalningsmetod vald";
  }
}
